module.exports = __webpack_public_path__ + "img/Differentiation-CRC_CRLM.7594e5df.png";